import { Outlet, useLocation } from 'react-router-dom';
import { AdminSidebar } from './AdminSidebar';
import { AdminHeader } from './AdminHeader';
import styles from './AdminLayout.module.css';

const PAGE_TITLES: Record<string, string> = {
  '/admin': 'Dashboard',
  '/admin/events': 'Events',
  '/admin/events/new': 'New Event',
  '/admin/registrations': 'Registrations',
  '/admin/sponsors': 'Sponsors',
  '/admin/news': 'Announcements',
  '/admin/settings': 'Site Settings',
};

export function AdminLayout() {
  const { pathname } = useLocation();
  const title = PAGE_TITLES[pathname] ?? 'Admin';

  return (
    <div className={styles.layout}>
      <AdminSidebar />
      <div className={styles.main}>
        <AdminHeader title={title} />
        <div className={styles.content}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
